// Get API URL from environment variables, fallback to default
const domainUrl = process.env.REACT_APP_API_URL || 'http://localhost:8002/';
// const domainUrl = 'https://tuneplusbackend.onrender.com/';
// const domainUrl = 'http://192.168.1.18:8001/';
// const endpoint = "https://api.ridd.in/api/"


const mainUrl = domainUrl
const imageServerUrl = process.env.REACT_APP_IMAGE_SERVER_URL || domainUrl + '';
const USER_TYPE = process.env.REACT_APP_USER_TYPE || "User"
const base = {
  login: mainUrl + 'auth/login',
  signUp: mainUrl + 'auth/signup',
  forgetPassword: mainUrl + 'auth/forgetpassword',
  setPassword: mainUrl + 'auth/setPassword',
  verifyOtp: mainUrl + 'auth/verifyOtp',
  changePassword: mainUrl + 'auth/user-change-password',
  addOneRelease: mainUrl + "release/add-one-release",
  releaseStep1: mainUrl + 'release/step-one-release',
  releaseStep2: mainUrl + 'release/step-two-release',
  deleteFile: mainUrl + 'release/deletefile',
  releaseStep3: mainUrl + 'release/step-three-release',
  deleteTrack: mainUrl + 'release/deleteTrack',
  releaseStep5: mainUrl + 'release/step-five-release',
  finalReleaseSubmit: mainUrl + 'release/SubmitFinalRelease',
  releaseList: mainUrl + 'release/release-list',
  allDraftList: mainUrl + 'release/all-draft-list',
  allReleaseList: mainUrl + 'release/all-release-list',
  adminAllReleaseList: mainUrl + 'release/admin-all-release-list',
  releaseDetails: mainUrl + 'release/release-details',
  deleteOneRelease:  mainUrl + 'release/release-delete',
  deleteUserparmanent:  mainUrl + 'auth/user-permanentdelete',
  addArtist: mainUrl + 'artist/add-artist',
  fetchArtistList: mainUrl + 'artist/artist-list',
  userProfile: mainUrl + 'auth/user-profile',
  addLabel: mainUrl + 'release/add-label',
  labelList: mainUrl + 'release/label-list',
  trackUpdate: mainUrl + 'release/tracks-update',
  addStore: mainUrl + 'release/step-four-release',
  listStore: mainUrl + 'release/list-store',
  tracksList: mainUrl + 'release/tracks-list',
  addSupport: mainUrl + 'support/add-support',
  supportList: mainUrl + 'support/support-list',
  addBank: mainUrl + 'bank/add-bank',
  bankDetails: mainUrl + 'bank/bank-details',
  updateProfile: mainUrl + 'auth/profile-update',
  addPermission: mainUrl + 'permission/add-permission',
  myPermission: mainUrl + 'permission/my-permission',
  getUserList: mainUrl + 'permission/my-user-list',
  sendWithdrawal: mainUrl + 'wallet/send-withdrawal',
  getWithdraw: mainUrl + 'wallet/get-withdrawal-by-id',
  updatePermission: mainUrl + 'permission/update-permission',
  userList: mainUrl + 'auth/user-list',
  deleteUser: mainUrl + 'auth/user-delete',
  getWithdrawList: mainUrl + 'wallet/get-withdraw-request',
  withdrawStatus: mainUrl + 'wallet/withdraw-status',
  uploadTracks: mainUrl + 'excel/send-track',
  getTracks: mainUrl + 'excel/get-track',
  uploadStore: mainUrl + 'excel/sent-store',
  getStore: mainUrl + 'excel/get-store',
  sendReport: mainUrl + 'excel/sent-salesAsset',
  getReport: mainUrl + 'excel/get-salesAsset',
  sendInside:mainUrl+'excel/sent-insides',
  getInside:mainUrl+'excel/get-insides',
  getFilterReport: mainUrl + 'excel/getFilterReport',
  sendReport: mainUrl + 'excel/sent-salesAsset',
  getReport: mainUrl + 'excel/get-salesAsset',
  getFilterReport: mainUrl + 'excel/getFilterReport',
  uploadMarket: mainUrl + 'excel/sent-market',
  getMarket: mainUrl + 'excel/get-market',
  sendStream: mainUrl + 'excel/sent-stream',
  getStream: mainUrl + 'excel/get-stream',
  addCompany: mainUrl + 'company/addCompany',
  publicCompanyRegister: mainUrl + 'company/public-register', // Public company registration endpoint
  releaseChangeStatus: mainUrl + 'release/release-update-status',
  getReportbydate: mainUrl + 'excel/get-report-by-date',
  getUser: mainUrl + "auth/get-user",
  userMemberships: mainUrl + "admin/user-memberships",
  dashboardCount: mainUrl+"dashboard/get-dashboard-list",
  getAllReport: mainUrl + "excel/get-all-report",
  deleteStore: mainUrl + "excel/delete-report",
  downloadDb: mainUrl + "setting/downloadDb",
  uploadExcelFile: mainUrl + "upload/excel",
  getFincialReport: mainUrl + 'report/getreport',
  uploadFinancialReport: mainUrl +'upload/reportExcel',
  deleteReport: mainUrl +'report/deleteReport',
  updateWallet: mainUrl +'auth/walletUpdate', 

  uploadTracksReport: mainUrl + 'report/send-track-report',
  getTracksReport: mainUrl +'report/get-track-report',
  deleteTrackReport: mainUrl +'report/delete-track-report',
  uploadStoreReport: mainUrl +'report/sent-store-report',
  getStoreReport: mainUrl +'report/get-store-report',
  uploadMarketReport: mainUrl +'report/sent-market-report',
  getMarketReport: mainUrl +'report/get-market-report',
  uploadOverviewReport: mainUrl +'report/send-overview-report',
  getOverViewReport: mainUrl +'report/get-overview-report',
  getAllFinancialReport: mainUrl + "report/get-all-financial-report",
  deleteFinancialReport: mainUrl + "report/delete-financial-report",
  uploadReportExcelFile: mainUrl + "upload/reportExcel",

  // Membership endpoints
  addMembership: mainUrl + 'admin/add-membership',
  membershipList: mainUrl + 'admin/membership-list',
  getMembershipById: mainUrl + 'admin/membership',
  updateMembership: mainUrl + 'admin/update-membership',
  deleteMembership: mainUrl + 'admin/delete-membership',
  changeMembershipStatus: mainUrl + 'admin/change-membership-status',
  activeMemberships: mainUrl + 'admin/active-memberships',
  updateUserPlan: mainUrl + 'admin/update-user-plan',
  
  // Payment endpoints
  createPaymentOrder: mainUrl + 'payment/create-order',
  verifyPayment: mainUrl + 'payment/verify',
  
  // Master Artist endpoints
  addMasterArtist: mainUrl + 'admin/add-master-artist',
  masterArtistList: mainUrl + 'admin/master-artist-list',
  getMasterArtistById: mainUrl + 'admin/master-artist',
  updateMasterArtist: mainUrl + 'admin/update-master-artist',
  deleteMasterArtist: mainUrl + 'admin/delete-master-artist',
  changeMasterArtistStatus: mainUrl + 'admin/change-master-artist-status',
  activeMasterArtists: mainUrl + 'admin/active-master-artists',
  
  // Master Label endpoints
  addMasterLabel: mainUrl + 'admin/add-master-label',
  masterLabelList: mainUrl + 'admin/master-label-list',
  getMasterLabelById: mainUrl + 'admin/master-label',
  updateMasterLabel: mainUrl + 'admin/update-master-label',
  deleteMasterLabel: mainUrl + 'admin/delete-master-label',
  changeMasterLabelStatus: mainUrl + 'admin/change-master-label-status',
  activeMasterLabels: mainUrl + 'admin/active-master-labels',
  
};
export { base, domainUrl, imageServerUrl, USER_TYPE };
